import { render, staticRenderFns } from "./billing-record-list-ren-bao.vue?vue&type=template&id=1a8247cd&"
import script from "./billing-record-list-ren-bao.vue?vue&type=script&lang=js&"
export * from "./billing-record-list-ren-bao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports